import { useState } from "react";
import { Col, Container, Row, Form, Alert, Button } from "react-bootstrap";
import { useGetCmsPageQuery } from "store/services/cms";
import parse from "html-react-parser";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useAcceptTermsMutation, useGetProfileQuery } from "store/services/auth";
import LoadingButton from "components/shared/LoadingButton";
import { Link, Navigate } from "react-router-dom";
import { PRIVACY_POLICY, SCHOOL_CLIENT_LIST, TERMS_AND_CONDITIONS } from "config/paths";
import { useSelector } from "react-redux";
import { useLogoutMutation } from "store/services/sso";

const AcceptTerms = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  
  const [logout, { isLoading: logoutLoading }] = useLogoutMutation();
  const [acceptTerms, { isLoading: isAccepting, isSuccess, isError }] = useAcceptTermsMutation();
  const { data, isLoading, isFetching } = useGetCmsPageQuery("terms_conditions");
  const { data: user } = useGetProfileQuery();
  

  const handleAccept = async () => {
    setSubmitted(true);
    if (!isChecked) return;
    try {
      await acceptTerms({ termsAndConditionsStatus: "accepted" });
    } catch (err) {
      console.error("Failed to accept terms", err);
    }
  };

  if(user?.termsAndConditionsStatus === "accepted") {
    return <Navigate to={SCHOOL_CLIENT_LIST} />
  }

  return (
    <section className="client position-relative py-4">
      <Container fluid>
        <Row>
          {isLoading || isFetching ? (
            <LoadingIndicator />
          ) : (
            <Col lg="12" className="my-3">
              <h3 className="fw-bold">{data?.title || ""}</h3>

              {data?.cover_img && (
                <img
                  style={{ width: "100%", height: "400px", objectFit: "fill" }}
                  src={data?.cover_img}
                  alt="Terms Cover"
                />
              )}

              <div className="w-100 my-3">{parse(data?.description || "")}</div>

              <p className="mt-5">
                By proceeding, you agree to our{" "}
                <Link to={TERMS_AND_CONDITIONS} target="_blank">
                  Terms & Conditions
                </Link>{" "}
                and{" "}
                <Link to={PRIVACY_POLICY} target="_blank">
                  Privacy Policy
                </Link>.
              </p>

              <Row>
                <Col lg="12" className="mx-auto">
                  <div className="d-flex justify-content-between align-items-center">
                    <Form.Check
                      type="checkbox"
                      label="I have read and accept the Terms & Conditions and Privacy Policy"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      isInvalid={submitted && !isChecked}
                    />
                    <div className="d-flex gap-2">
                      <Button
                        className="mx-2 d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                        type="button"
                        onClick={logout}
                        disabled={logoutLoading}
                      >
                        {logoutLoading ? "Logging out..." : "Cancel"}
                      </Button>
                      <LoadingButton
                        className="d-flex align-items-center justify-content-center commonBtn"
                        onClick={handleAccept}
                        isLoading={isAccepting}
                      >
                        Accept Terms
                      </LoadingButton>
                    </div>
                  </div>
                </Col>
              </Row>
              
              {isSuccess && (
                <Alert variant="success" className="mt-3">
                  Terms accepted successfully!
                </Alert>
              )}
              {isError && (
                <Alert variant="danger" className="mt-3">
                  Something went wrong. Please try again.
                </Alert>
              )}
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default AcceptTerms;
